import React, { useEffect } from 'react';
import { CheckIcon, CloseIcon, HelpIcon } from './Icons';

interface ToastProps {
  message: string;
  type?: 'success' | 'error' | 'info';
  onClose: () => void;
  duration?: number;
}

const styles = {
  success: { accent: 'bg-emerald-500', icon: CheckIcon },
  error: { accent: 'bg-rose-500', icon: CloseIcon },
  info: { accent: 'bg-primary-600', icon: HelpIcon },
};

export const Toast: React.FC<ToastProps> = ({
  message,
  type = 'info',
  onClose,
  duration = 3000,
}) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  const { accent, icon: Icon } = styles[type];

  return (
    <div className="fixed bottom-5 right-5 z-[60] animate-fade-up">
      <div className="flex items-center gap-3 rounded-2xl border border-canvas-200 bg-white py-3 pl-3 pr-4 shadow-card-hover">
        <span className={`flex h-8 w-8 items-center justify-center rounded-xl text-white ${accent}`}>
          <Icon width={16} height={16} />
        </span>
        <span className="max-w-xs text-sm text-canvas-800">{message}</span>
        <button
          onClick={onClose}
          className="rounded-lg p-1 text-canvas-400 transition-colors hover:bg-canvas-100 hover:text-canvas-700"
          aria-label="Dismiss"
        >
          <CloseIcon width={15} height={15} />
        </button>
      </div>
    </div>
  );
};
